<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>项目名称：</span>
        <Input style="width:180px;" placeholder="模糊查询" v-model="searchForm['title']"></Input>
      </div>
      <div class="search">
        <span>项目编号：</span>
        <Input style="width:180px;" placeholder="模糊查询" v-model="searchForm['projectNum']"></Input>
      </div>
      <div class="search">
        <span>投标单位：</span>
        <Input style="width:200px;" v-model="searchForm['ghfCompanyName']"></Input>
      </div>
      <div class="search">
        <span>汇款方式：</span>
        <Select style="width:100px" v-model="searchForm.payChannel">
          <Option v-for="item in payWays" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <div class="search">
        <span>金额：</span>
        <InputNumber style="width:80px;" v-model="searchForm['orderAmountTotal']"></InputNumber>
      </div>
      <div class="search">
        <span>收款日期：</span>
        <DatePicker type="date" v-model="searchForm['payTime']" style="width: 100px"></DatePicker>
      </div>
      <div class="search">
        <span>审核类型：</span>
        <Select style="width:100px" v-model="searchForm.auditType" @on-change="init(1)">
          <Option v-for="item in auditList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <Button type="primary" icon="ios-search" style="margin: 0 10px;" @click="search">搜索</Button>
      <Button icon="ios-loop-strong" type="primary" style="margin-right:5px;" @click="resetSearch">重置搜索</Button>
    </div>
    <Spin :fix="true" v-if="pageSpin"></Spin>
    <!-- 数据列表 -->
    <Table :columns="columns.concat(searchForm.auditType === '报名审核' ? signOption : auditOption)" :data="tableData" style="min-width:1300px;"></Table>
    <Page ref="page" @on-change="pageChange" :total="pageTotal" :current="currentPage" show-elevator show-total style="margin:5px;"></Page>
    <!-- 确认信息 -->
    <Modal
      v-model="showAudit"
      title="确认信息"
    >
      <Form
        ref="confirmForm"
        :model="confirmForm"
        :rules="auditRules"
        :label-width="150"
      >
        <Row>
          <FormItem label="银行账号:" prop="ghfBankAccount">
            <Input
              v-model="confirmForm.ghfBankAccount"
              style="width: 80%;"
            >
            </Input>
          </FormItem>
        </Row>
        <Row>
          <FormItem label="收款日期:" prop="payTime">
            <Date-picker
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              v-model="confirmForm.payTime"
              placeholder="选择收款日期"
              style="width: 80%;"
            ></Date-picker>
          </FormItem>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="ghost" @click="showAudit=false">取消</Button>
        <Button type="primary" :loading="auditLoading" @click="auditOk">确定</Button>
      </div>
    </Modal>
    <!-- 流程信息 -->
    <Modal
      v-model="processShow"
      title="流程详情"
      class="processModal"
      :width="600"
    >
      <Table :columns="processColumns" :data="process"></Table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

// 订单状态 0：未确认 1：已确认 2：线上支付未确认
export default {
  computed: {
    user() {
      return this.$store.state.session.user
    }
  },
  data() {
    return {
      baseUrl: 'https://api.choicelink.cn/NewFinancial',  // 接口url开头
      searchForm: {
        auditType: '报名审核',
        title: '',
        projectNum: '',
        ghfCompanyName: '',
        payChannel: '',
        orderAmountTotal: null
      },  //当前搜索框
      auditList: [
        {
          value: '报名审核',
          label: '报名审核'
        },
        {
          value: '退保审核',
          label: '退保审核'
        }
      ], // 审核类型列表
      payWays: [
        {
          value: '对公支付',
          label: '对公支付'
        },
        {
          value: '余额支付',
          label: '余额支付'
        },
        {
          value: '全部',
          label: '全部'
        }
      ],  //订单状态
      tableData: [],
      columns: [
        {
          title: '项目名称',
          key: 'title'
        },
        {
          title: '项目编号',
          key: 'projectNum'
        },
        {
          title: '投标单位',
          key: 'ghfCompanyName'
        },
        {
          title: '保证金金额',
          width: 100,
          align: 'center',
          key: 'orderAmountTotal'
        },
        {
          title: '汇款方式',
          width: 100,
          align: 'center',
          key: 'payChannel'
        },
        {
          title: '银行账号',
          width: 120,
          key: 'ghfBankAccount'
        },
        {
          title: '收款日期',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return params.row.payTime ? h('div', moment(params.row.payTime).format('YYYY-MM-DD')) : h('div', '/')   // 时间格式化
          }
        },
        {
          title: '附件',
          width: 200,
          align: 'center',
          render: (h, params) => {
            if (params.row.payChannel === '对公支付') {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: async () => {
                      try {
                        this.$Spin.show()
                        let orderNo = params.row.orderNo
                        if (this.searchForm.auditType === '退保审核') {
                          const originOrder = await axios.get(this.baseUrl + "/api/services/app/Orders/GetTotalPaged", {
                            params: {
                              filter: `redOrderNo="${orderNo}"`,
                              maxResultCount: 1,
                              skipCount: 0
                            }
                          })
                          orderNo = originOrder.data.result.items[0].orderNo
                        }
                        // 获取附件信息
                        let res = await axios.get(`${this.baseUrl}/api/services/app/Orders/GetPublishCheck`, {
                          params: {
                            orderNo
                          }
                        })
                        res = res.data.result.data.items.filter(fil => fil.type === '保证金')
                        res.sort((a, b) => moment(b.addTime) - moment(a.addTime))
                        if (res.length) {
                          window.open(res[0].fileUrl)
                        } else {
                          this.$Message.info('无相关附件')
                        }
                      } catch (error) {
                        this.$Message.error('加载失败')
                      } finally {
                        this.$Spin.hide()
                      }
                    }
                  }
                }, '电子转账凭证'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  style: {
                    'margin-left': '5px'
                  },
                  on: {
                    click: async () => {
                      try {
                        this.$Spin.show()
                        let orderNo = params.row.orderNo
                        if (this.searchForm.auditType === '退保审核') {
                          const originOrder = await axios.get(this.baseUrl + "/api/services/app/Orders/GetTotalPaged", {
                            params: {
                              filter: `redOrderNo="${orderNo}"`,
                              maxResultCount: 1,
                              skipCount: 0
                            }
                          })
                          orderNo = originOrder.data.result.items[0].orderNo
                        }
                        // 获取附件信息
                        let res = await axios.get(`${this.baseUrl}/api/services/app/Orders/GetPublishCheck`, {
                          params: {
                            orderNo
                          }
                        })
                        res = res.data.result.data.items.filter(fil => fil.type === '退保涵')
                        res.sort((a, b) => moment(b.addTime) - moment(a.addTime))
                        if (res.length) {
                          window.open(res[0].fileUrl)
                        } else {
                          this.$Message.info('无相关附件')
                        }
                      } catch (error) {
                        this.$Message.error('加载失败')
                      } finally {
                        this.$Spin.hide()
                      }
                    }
                  }
                }, '退保函')
              ])
            }
          }
        }
      ],
      signOption: [
        {
          title: '状态',
          width: 80,
          align: 'center',
          render: (h, params) => {
            // let orderStatus = params.row.orderStatus
            // let auditStatus = params.row.financialCharges.auditStatus
            let status = params.row.financialCharges.status
            if (status === '2') {
              return h('div', {
                style: {
                  color: '#2d8cf0'
                }
              },'未确认')
            } else if (status === '1') {
              return h('div', {
                style: {
                  color: '#45AD4C'
                }
              },'已确认')
            } else if (status === '0') {
              return h('div', {
                style: {
                  color: '#f30'
                }
              },'已退回')
            }
          }
        },
        {
          title: '操作',
          width: 125,
          render: (h, params) => {
            let status = params.row.financialCharges.status
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: status === '0' || status === '1'
                },
                on: {
                  click: () => {
                    this.currentOrder = params.row
                    this.showAudit = true
                  }
                }
              }, '确认'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: status === '0' || status === '1'
                },
                style: {
                  'margin-left': '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '审核退回',
                      content: '是否确认退回？',
                      render: (h) => {
                        return h('div', {
                          style: {
                            'margin-top': '15px'
                          }
                        }, [
                          h('span','退回原因：'),
                          h('Input', {
                            props: {
                              value: this.returnReason,
                              type: 'textarea'
                            },
                            on: {
                              input: (val) => {
                                this.returnReason = val;
                              }
                            }
                          })
                        ])
                      },
                      loading: true,
                      onOk: async () => {
                        try {
                          // 修改订单状态
                          let order = Object.assign(params.row, {
                            orderStatus: '4'
                          })
                          order.financialCharges.auditStatus = '2'
                          order.financialCharges.status = '0'
                          await axios.post(this.baseUrl + "/api/services/app/Orders/ModifyWhatever", {
                            accessKey: 'RILKvl1ODfZhS3g7',
                            body: order
                          })
                          // 退回原因
                          const returnData = {
                            orderNo: order.orderNo,
                            addTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                            fileName: this.returnReason,
                            type: '退回原因'
                          }
                          await axios.post(this.baseUrl + "/api/services/app/Orders/CreatePublishCheck", returnData)
                          this.$Message.success('退回成功！')
                          this.init(this.currentPage)
                        } catch (error) {
                          this.$Message.error('操作失败！')
                        } finally {
                          this.returnReason = ''
                          this.$Modal.remove()
                        }
                      },
                      onCancel: () => {
                        this.returnReason = ''
                      }
                    })
                  }
                }
              }, '退回')
            ])
          }
        }
      ],
      auditOption: [
        {
          title: '状态',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let orderStatus = params.row.orderStatus
            if (orderStatus === '1') {
              return h('div', {
                style: {
                  color: 'red'
                }
              },'未退回')
            } else if (orderStatus === '2') {
              return h('div', {
                style: {
                  color: '#19be6b'
                }
              },'已退回')
            }
          }
        },
        {
          title: '操作',
          width: 250,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: async () => {
                    try {
                      this.$Spin.show()
                      this.process = []
                      // 查询流程
                      const pro = await axios.get(`${this.baseUrl}/api/services/app/Orders/GetPublishCheck`, {
                        params: {
                          orderNo: params.row.orderNo
                        }
                      })
                      this.process = pro.data.result.data.items
                      this.process.sort((a, b) => {
                        return moment(a.addTime) - moment(b.addTime)
                      })
                      if (this.process.length === 1) {
                        this.process.push({
                          fileName: '财务',
                          fileUrl: '待办',
                          type: '退回'
                        })
                      }
                      this.processShow = true
                    } catch (error) {
                      console.log(error)
                      this.$Message.error('加载失败')
                    } finally {
                      this.$Spin.hide()
                    }
                  }
                }
              }, '申请流程'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: params.row.orderStatus === '2'
                },
                style: {
                  'margin-left': '5px'
                },
                on: {
                  click: () => {
                    this.payConfirm(params.row)
                  }
                }
              }, '退回保证金'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  display: params.row.payChannel === '余额支付' ? '' : 'none',
                  'margin-left': '5px'
                },
                on: {
                  click: async () => {
                    try {
                      this.$Spin.show()
                      const left = await axios.get(`https://middleware.choicelink.cn/margin_docking/api/public/getSubAccountBalance`, {
                        params: {
                          subAcctNo: params.row.ghfBankAccount
                        }
                      })
                      this.$Message.info({
                        content: `${params.row.ghfCompanyName}账号余额：${left.data.result.amount}元`,
                        duration: 10
                      })
                    } catch (error) {
                      console.log(error)
                      this.$Message.error('查询失败')
                    } finally {
                      this.$Spin.hide()
                    }
                  }
                }
              }, '余额查询')
            ])
          }
        }
      ],
      currentPage: 1,
      pageTotal: 0,
      showAudit: false,
      auditLoading: false, // 审核确认loading
      currentOrder: {},
      confirmForm: {
        ghfBankAccount: '',
        payTime: null
      },
      auditRules: {
        ghfBankAccount: [
          { required: true, message: '银行账号不能为空', trigger: 'blur' }
        ],
        payTime: [
          { required: true, type: 'date', message: '收款日期不能为空', trigger: 'blur' }
        ]
      },
      returnReason: '', //回退原因
      processShow: false, // 流程显示
      process: [], // 流程数据
      processColumns: [
        {
          title: '操作类型',
          key: 'type'
        },
        {
          title: '操作人',
          key: 'fileName'
        },
        {
          title: '执行结果',
          key: 'fileUrl',
          render: (h, params) => {
            return h('ul', {
              style: {
                margin: '0'
              },
              class: params.row.addTime ? 'success' : 'remain'
            }, [
              h('li', params.row.fileUrl)
            ])
          }
        },
        {
          title: '操作时间',
          key: 'addTime',
          render: (h, params) => {
            return h('span', params.row.addTime ? moment(params.row.addTime).format('YYYY-MM-DD') : '')
          }
        },
        {
          title: '备注',
          key: 'items'
        }
      ]
    }
  },
  async created() {
    this.init(1)
  },
  methods: {
    // 获取数据列表
    async init(page) {
      this.pageSpin = true
      // 基本过滤条件
      let baseFil = 'orderType="保证金" and SourceId="29FCA177-F681-4FAB-982D-997494AE35E1" and !ghfCompanyName.contains("供应商") and !projectNum.contains("E440")'
      if (this.searchForm.auditType === '退保审核') {
        baseFil += ' and orderAmountTotal < 0'
      } else {
        baseFil += ' and orderStatus!="1"'
      }
      let title = this.searchForm.title ? ` and title.Contains("${this.searchForm.title}")` : ''
      let projectNum = this.searchForm.projectNum ? ` and projectNum.Contains("${this.searchForm.projectNum}")` : ''
      let ghfCompanyName = this.searchForm.ghfCompanyName ? ` and ghfCompanyName.Contains("${this.searchForm.ghfCompanyName}")` : ''
      let orderAmountTotal = this.searchForm.orderAmountTotal ? ` and orderAmountTotal=="${this.searchForm.orderAmountTotal}"` : ''
      let payChannel = this.searchForm.payChannel && this.searchForm.payChannel !== '全部' ? ` and payChannel=="${this.searchForm.payChannel}"` : ``
      let payTime = this.searchForm.payTime ? ` and (payTime > "${moment(this.searchForm.payTime).format('YYYY-MM-DD HH:mm:ss')}" and payTime < "${moment(this.searchForm.payTime).add(1, 'days').format('YYYY-MM-DD HH:mm:ss')}")` : ''
      let query = baseFil + title + projectNum + ghfCompanyName + payChannel + orderAmountTotal + payTime
      axios.get(this.baseUrl + "/api/services/app/Orders/GetTotalPaged", {
        params: {
          filter: query,
          maxResultCount: 10,
          skipCount: (page - 1) * 10
        }
      }).then(res => {
        this.pageTotal = res.data.result.totalCount
        this.tableData = res.data.result.items
        this.pageSpin = false
      }).catch(err => {
        this.$Message.error('数据请求失败！')
      })
    },
    // 分页
    pageChange(page) {
      this.tableData = []
      this.currentPage = page
      this.init(page)
    },
    // 搜索按钮
    search(e) {
      // e 判断是否组件刷新
      this.currentPage = e == '1' ? this.currentPage : 1
      this.tableData = []
      this.init(this.currentPage)
    },
    // 重置搜索
    resetSearch() {
      this.currentPage = 1
      this.searchForm = {
        title: '',
        projectNum: '',
        ghfCompanyName: '',
        payChannel: '',
        orderAmountTotal: null
      }
      this.init(1)
    },
    // 确认审核
    auditOk () {
      this.$refs.confirmForm.validate(async val => {
        console.log(val, this.confirmForm)
        if (val) {
          try {
            this.auditLoading = true
            // 修改订单状态
            let order = Object.assign(this.currentOrder, {
              orderStatus: '2',
              payTime: moment(this.confirmForm.payTime).format('YYYY-MM-DD HH:mm:ss'),
              ghfBankAccount: this.confirmForm.ghfBankAccount
            })
            order.financialCharges.auditStatus = '1'
            order.financialCharges.status = '1'
            await axios.post(this.baseUrl + "/api/services/app/Orders/ModifyWhatever", {
              accessKey: 'RILKvl1ODfZhS3g7',
              body: order
            })
            this.showAudit = false
            this.$Message.success('已通过')
            this.init(this.currentPage)
          } catch (error) {
            this.$Message.error('确认失败，请重试！')
          } finally {
            this.auditLoading = false
          }
        }
      })
    },
    // 确认退回
    payConfirm (currentOrder) {
      this.$Modal.confirm({
        title: '保证金退回',
        content: '是否确认退回？',
        loading: true,
        onOk: async () => {
          try {
            // 修改订单状态
            let order = Object.assign(currentOrder, {
              orderStatus: '2',
              payTime: moment().format('YYYY-MM-DD HH:mm:ss')
            })
            order.financialCharges.auditStatus = '1'
            order.financialCharges.status = '1'
            await axios.post(this.baseUrl + "/api/services/app/Orders/ModifyWhatever", {
              accessKey: 'RILKvl1ODfZhS3g7',
              body: order
            })
            if (order.payChannel === '余额支付') {
              // 划款
              await axios.post('https://middleware.choicelink.cn/margin_docking/api/public/refund', {
                openBankName: order.ghfBankName, // 收款账户开户行名称
                realRefundAmount: Math.abs(order.orderAmountTotal), // 实际退款金额
                receiveMoneyAcct: order.ghfBankAccount, // 收款人账号
                receiveMoneyBankNumber: order.ghfBankNum, // 收款账户开户行行号
                receiveMoneyName: order.ghfCompanyName, // 收款人名称
                refundAmount: Math.abs(order.orderAmountTotal), // 要求退款金额
                refundTime: moment().format('YYYYMMDDhhmmss'), // 要求退款时间
                subAcct: order.xhfBankAccount, // 子账号
                totalAmt: Math.abs(order.orderAmountTotal), // 总金额
                tkType: 1, // 1=非原路退款；2=原路退款
                totalNum: 1,
                detailInterest: '0.00',
                interest: false,
                remCharge: false,
                transferFee: '0.00'
              })
            }
            // 通过流程
            const returnData = {
              orderNo: order.orderNo,
              addTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              fileName: '财务',
              fileUrl: '通过',
              type: '退回'
            }
            await axios.post(this.baseUrl + "/api/services/app/Orders/CreatePublishCheck", returnData)
            this.$Message.success('退回成功！')
            this.init(this.currentPage)
          } catch (error) {
            console.log(error)
            this.$Message.error('操作失败')
          } finally {
            this.$Modal.remove()
          }
        }
      })
    }
  },
  watch: {
    showAudit (val) {
      if (!val) {
        this.$refs.confirmForm.resetFields()
      }
    }
  }
}
</script>

<style lang="less">
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .input-enroll {
    width: 100px;
    display: inline-block;
  }
}
.processModal {
  .success {
    li::marker {
      color: #3DBD7D;
    }
  }
  .remain {
    li::marker {
      color: #f80;
    }
  }
}
</style>